// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoginPage_wrapper__2hmus","header":"LoginPage_header__3r17J","signUp":"LoginPage_signUp__2MI9_"};